var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVietlottIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_30664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7773 22.959C10.7773 16.3316 16.1499 10.959 22.7773 10.959H33.7773C40.4048 10.959 45.7773 16.3316 45.7773 22.959V45.959H22.7773C16.1499 45.959 10.7773 40.5864 10.7773 33.959V22.959Z",
    fill: "url(#paint0_linear_588_30664)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_588_30664)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_30664)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_588_30664)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_588_30664)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.645 23.1578C26.7972 23.7928 28.0193 24.0674 29.3111 24.0503C29.445 24.0503 29.5788 24.0484 29.7127 24.0465C29.9804 24.0426 30.248 24.0388 30.5157 24.0503C30.8125 24.0674 30.9696 23.9816 31.0569 23.6727L31.0779 23.592C31.2631 22.8797 31.4518 22.1538 31.7378 21.4757C32.1044 20.5832 31.6156 20.137 30.8474 19.9825C29.6603 19.725 28.4732 19.7079 27.2686 19.8109C25.9767 19.931 24.807 20.4287 23.6723 20.9951C23.4104 21.1325 23.1311 21.3384 23.1486 21.6817C23.1642 21.9734 23.4032 22.0865 23.6284 22.1932C23.655 22.2057 23.6814 22.2182 23.7072 22.2309C23.9225 22.3339 24.1398 22.4331 24.357 22.5322C24.7915 22.7306 25.226 22.9289 25.645 23.1578ZM27.4234 24.8725C27.9292 24.8557 28.3989 25.0066 28.8144 25.2579C29.0203 25.3852 29.2229 25.5185 29.4251 25.6515L29.4251 25.6515C29.7019 25.8336 29.9778 26.015 30.2596 26.1797C30.4945 26.3137 30.5306 26.4478 30.4403 26.6824C30.3409 26.9254 30.2551 27.1684 30.1693 27.4114L30.1693 27.4114L30.1693 27.4114L30.1693 27.4114L30.1693 27.4115C30.0835 27.6545 29.9977 27.8974 29.8983 28.1404C29.6454 28.7773 29.248 29.3135 28.6519 29.7325C27.3376 30.6523 26.0307 31.5789 24.7264 32.5036L24.7263 32.5037L24.7261 32.5038L24.726 32.5039C23.9867 33.0281 23.2482 33.5516 22.5097 34.073C21.6788 34.6596 21.0826 34.559 20.5407 33.7378C18.9509 31.3246 18.5535 28.7773 19.511 26.0623C19.7277 25.4255 20.0168 25.2244 20.7574 25.1909C21.8684 25.1406 22.9794 25.0862 24.0904 25.0317C25.2014 24.9772 26.3124 24.9228 27.4234 24.8725ZM28.7506 37.7296H28.384C27.3714 37.661 27.0572 37.2147 27.354 36.2707C27.5167 35.7358 27.6809 35.1994 27.8453 34.6625L27.8454 34.662L27.8455 34.6615L27.8457 34.6611L27.8458 34.6608L27.8458 34.6607C28.2456 33.3547 28.6465 32.0451 29.0299 30.7441C29.3791 29.5769 29.9726 28.5986 31.055 27.9464C31.1793 27.8708 31.3015 27.7695 31.4224 27.6694C31.6583 27.474 31.8891 27.2828 32.1199 27.2942C32.3627 27.3061 32.5971 27.5172 32.8347 27.7313L32.8347 27.7313L32.8347 27.7313L32.8347 27.7313C32.9388 27.8251 33.0436 27.9195 33.1499 27.9979L33.2773 28.094C33.4564 28.2288 33.6261 28.3566 33.7959 28.4956C34.2498 28.8732 34.5989 29.3023 34.7909 29.8687L34.8503 30.0383C35.1974 31.0303 35.5487 32.0345 35.9781 32.9925C36.3272 33.7992 36.1527 34.3999 35.5591 34.9835C34.145 36.3737 32.4516 37.1976 30.4964 37.5408C30.1123 37.6095 29.7282 37.6476 29.3441 37.6858C29.1521 37.7049 28.9601 37.7239 28.768 37.7468C28.7593 37.7468 28.7549 37.7468 28.7527 37.7446C28.7506 37.7425 28.7506 37.7382 28.7506 37.7296ZM38.1415 29.2364V29.2365C38.1474 29.5446 38.1537 29.8783 38.0546 30.1948C37.8975 30.6925 37.6357 30.7955 37.2167 30.5209C36.5882 30.0918 35.9597 29.6627 35.3487 29.2165C34.9472 28.9247 34.7202 28.4784 34.5456 28.0322C34.4095 27.682 34.2922 27.3319 34.1748 26.9818C34.0966 26.7483 34.0184 26.5149 33.9346 26.2815C33.8648 26.0927 33.9346 25.9897 34.0917 25.8696C34.406 25.655 34.7202 25.4362 35.0345 25.2174L35.0348 25.2171C35.349 24.9983 35.6631 24.7796 35.9772 24.5651C36.5533 24.1704 36.9548 24.2734 37.2865 24.8741C37.8102 25.8352 38.1419 27.3456 38.1419 28.8732C38.1369 28.988 38.1392 29.1101 38.1415 29.2364ZM34.1952 24.0464C34.3232 24.0483 34.4512 24.0502 34.5792 24.0502C34.9808 24.0502 35.3823 24.0502 35.7664 24.0674C36.0282 24.0674 36.2552 23.9816 36.3774 23.7413C36.4763 23.5306 36.3262 23.3658 36.1915 23.2181C36.1836 23.2093 36.1757 23.2007 36.1679 23.192C35.5569 22.5227 34.9109 21.9219 34.1777 21.3899L34.1777 21.3899C33.8285 21.1324 33.4794 20.875 33.0604 20.772C32.4843 20.6175 32.1526 20.9264 32.3272 21.4928C32.4323 21.8427 32.545 22.1927 32.6582 22.5443C32.7893 22.9515 32.9212 23.3611 33.043 23.7756C33.1128 23.9816 33.2001 24.0502 33.427 24.0502C33.6831 24.0388 33.9391 24.0426 34.1952 24.0464Z",
    fill: "#FF9B63"
  })))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.063 22.5738C26.2152 23.2088 27.4372 23.4834 28.7291 23.4663C28.863 23.4663 28.9968 23.4644 29.1306 23.4625C29.3983 23.4587 29.666 23.4548 29.9337 23.4663C30.2305 23.4834 30.3876 23.3976 30.4749 23.0887L30.4959 23.008C30.681 22.2957 30.8698 21.5698 31.1557 20.8917C31.5223 19.9992 31.0335 19.553 30.2654 19.3985C29.0783 19.1411 27.8911 19.1239 26.6866 19.2269C25.3947 19.347 24.225 19.8448 23.0903 20.4112C22.8284 20.5485 22.5491 20.7544 22.5665 21.0977C22.5821 21.3894 22.8212 21.5026 23.0464 21.6092C23.073 21.6218 23.0994 21.6343 23.1252 21.6469C23.3405 21.7499 23.5577 21.8491 23.775 21.9483C24.2095 22.1466 24.644 22.3449 25.063 22.5738ZM26.8414 24.2885C27.3472 24.2717 27.8169 24.4226 28.2324 24.6739C28.4383 24.8013 28.6409 24.9346 28.8431 25.0675L28.8431 25.0675C29.1199 25.2496 29.3957 25.431 29.6776 25.5957C29.9125 25.7297 29.9486 25.8638 29.8583 26.0984C29.7589 26.3414 29.6731 26.5844 29.5873 26.8274L29.5873 26.8274L29.5873 26.8274L29.5873 26.8274L29.5873 26.8275C29.5015 27.0705 29.4157 27.3135 29.3163 27.5564C29.0634 28.1933 28.666 28.7296 28.0698 29.1485C26.7555 30.0683 25.4486 30.9949 24.1444 31.9196L24.1442 31.9197L24.1441 31.9198L24.1439 31.9199C23.4046 32.4441 22.6662 32.9677 21.9277 33.489C21.0967 34.0756 20.5006 33.975 19.9586 33.1538C18.3689 30.7406 17.9715 28.1933 18.9289 25.4784C19.1457 24.8415 19.4347 24.6404 20.1754 24.6069C21.2864 24.5566 22.3974 24.5022 23.5084 24.4477C24.6194 24.3932 25.7304 24.3388 26.8414 24.2885ZM28.1686 37.1457H27.8019C26.7894 37.077 26.4752 36.6307 26.7719 35.6868C26.9346 35.1518 27.0988 34.6155 27.2632 34.0785L27.2634 34.078L27.2635 34.0776L27.2637 34.0771L27.2637 34.0768L27.2638 34.0767C27.6636 32.7707 28.0645 31.4611 28.4479 30.1601C28.797 28.993 29.3906 28.0146 30.473 27.3624C30.5972 27.2868 30.7195 27.1855 30.8404 27.0854C31.0763 26.89 31.3071 26.6989 31.5379 26.7102C31.7807 26.7221 32.015 26.9332 32.2527 27.1473L32.2527 27.1473L32.2527 27.1473L32.2527 27.1473C32.3568 27.2411 32.4615 27.3355 32.5679 27.4139L32.6953 27.51C32.8743 27.6448 33.0441 27.7726 33.2138 27.9116C33.6677 28.2892 34.0169 28.7183 34.2089 29.2847L34.2683 29.4543C34.6153 30.4464 34.9666 31.4505 35.396 32.4085C35.7452 33.2152 35.5706 33.8159 34.9771 34.3995C33.563 35.7897 31.8696 36.6136 29.9143 36.9569C29.5302 37.0255 29.1462 37.0637 28.7621 37.1018C28.5701 37.1209 28.378 37.1399 28.186 37.1628C28.1772 37.1628 28.1729 37.1628 28.1707 37.1606C28.1686 37.1585 28.1686 37.1542 28.1686 37.1457ZM37.5595 28.6525V28.6525C37.5653 28.9607 37.5716 29.2944 37.4726 29.6108C37.3155 30.1086 37.0536 30.2115 36.6346 29.9369C36.0062 29.5078 35.3777 29.0787 34.7667 28.6325C34.3651 28.3407 34.1382 27.8945 33.9636 27.4482C33.8274 27.0981 33.7101 26.7479 33.5928 26.3978C33.5146 26.1644 33.4364 25.9309 33.3526 25.6975C33.2828 25.5087 33.3526 25.4057 33.5097 25.2856C33.8239 25.071 34.1382 24.8522 34.4524 24.6334L34.4528 24.6331C34.7669 24.4144 35.081 24.1956 35.3951 23.9812C35.9712 23.5864 36.3728 23.6894 36.7045 24.2901C37.2282 25.2513 37.5599 26.7617 37.5599 28.2892C37.5548 28.404 37.5571 28.5261 37.5595 28.6525ZM33.6131 23.4624C33.7412 23.4643 33.8692 23.4662 33.9972 23.4662C34.3987 23.4662 34.8003 23.4662 35.1843 23.4834C35.4462 23.4834 35.6731 23.3976 35.7953 23.1573C35.8943 22.9466 35.7441 22.7818 35.6095 22.6341C35.6015 22.6253 35.5936 22.6167 35.5859 22.6081C34.9748 21.9387 34.3289 21.3379 33.5957 20.8059L33.5957 20.8059C33.2465 20.5484 32.8974 20.291 32.4784 20.188C31.9023 20.0335 31.5706 20.3425 31.7452 20.9089C31.8503 21.2588 31.963 21.6087 32.0762 21.9603C32.2073 22.3675 32.3391 22.7771 32.4609 23.1916C32.5308 23.3976 32.618 23.4662 32.845 23.4662C33.101 23.4548 33.3571 23.4586 33.6131 23.4624Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_30664",
    x: 0.777344,
    y: 0.958984,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.18 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_588_30664",
    x: 7.48828,
    y: 7.66602,
    width: 41.582,
    height: 41.584,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.103083 0 0 0 0 0.0458333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_588_30664",
    x: 8.99609,
    y: 9.75195,
    width: 39.1484,
    height: 37.9941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.18 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_588_30664",
    x: 8.99609,
    y: 9.75195,
    width: 39.1484,
    height: 37.9941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65 0 0 0 0 0.0619125 0 0 0 0 0.024375 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_588_30664",
    x1: 28.2773,
    y1: 10.959,
    x2: 28.2773,
    y2: 45.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA1515"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_30664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0703 28.75C18.0703 22.951 22.7713 18.25 28.5703 18.25C34.3693 18.25 39.0703 22.951 39.0703 28.75V39.25H28.5703C22.7713 39.25 18.0703 34.549 18.0703 28.75Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVietlottIcon);
export default __webpack_public_path__ + "static/media/vietlott-icon.99c274c0e079b533f2aab133c8813a34.svg";
export { ForwardRef as ReactComponent };